import { render, staticRenderFns } from "./FakeFormItem.vue?vue&type=template&id=271113aa&"
import script from "./FakeFormItem.vue?vue&type=script&lang=js&"
export * from "./FakeFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports